import type IRawPageSourceFetchResult from '@/interfaces/IRawPageSourceFetchResult';

/**
 * Produce a plain (non-reactive) placeholder result for a failed fetch.
 */
export function createErrorFetchResult(): IRawPageSourceFetchResult {
  return { data: null, statusCode: 0 };     // 0 still means “I fetched but got nothing”
}